const BASE_SOURCE_URL = `${process.env.GATSBY_WORDPRESS_URL_PROTOCOL}://${process.env.GATSBY_WORDPRESS_URL_PATH}`;

export const convertSourceUrlToLocal = (sourceUrl: string) => sourceUrl.replace(BASE_SOURCE_URL, '');
